/* ==========================================================================
   AKZERN YAPI — shared site engine v3
   Gerçek bilgi: tel 0850 241 77 48 · akzernyapi@gmail.com ·
   Rüstempaşa Mah. Çeşme Sok. No:9/C Yalova/Merkez · 1.500 ₺ üzeri ücretsiz kargo
   Sistemde taksit YOK.
   ========================================================================== */
const IMG  = "https://cdn.shopify.com/s/files/1/0938/5957/8140/files/";
const LIFE = (window.ASSET_BASE||"assets/img/");
const FREE_SHIP = 1500;

const INFO = {
  tel:"0850 241 77 48", telRaw:"08502417748",
  mail:"akzernyapi@gmail.com",
  adres:"Rüstempaşa Mah. Çeşme Sok. No:9/C, Yalova / Merkez"
};

/* favicon */
(function(){const l=document.createElement('link');l.rel='icon';l.type='image/png';l.href=(window.ASSET_BASE||'assets/')+'favicon.png';document.head.appendChild(l);})();

const MARK_SVG = `<svg viewBox="0 0 64 64"><rect width="64" height="64" rx="15" fill="#211E1B"/><path fill-rule="evenodd" fill="#F5F1EA" d="M32 11 L52 53 L43.4 53 L39.1 44 L24.9 44 L20.6 53 L12 53 Z M32 25 L27.2 38 L36.8 38 Z"/><rect x="26.5" y="40.5" width="11" height="3.6" rx="1.8" fill="#E5661C"/></svg>`;

/* store-aware URL helpers — tema layout'u window.SHOPIFY=true set eder; local prototipte statik sayfalar */
function colURL(h){return (window.SHOPIFY&&h)?('/collections/'+h):'koleksiyon.html';}
function prodURL(h){return (window.SHOPIFY&&h)?('/products/'+h):'urun.html';}
function cartURL(){return window.SHOPIFY?'/cart':'sepet.html';}
function allColURL(){return window.SHOPIFY?'/collections':'koleksiyon.html';}
function P(h){return window.SHOPIFY?('/pages/'+h):(h+'.html');}

/* ================= Dil (TR / EN) ================= */
function getLang(){ try{var l=localStorage.getItem('ak_lang'); if(l)return l;}catch(e){} if(window.SHOP_LOCALE){return window.SHOP_LOCALE.slice(0,2).toLowerCase();} return 'tr'; }
var I18N={
"1.500 ₺ üzeri ücretsiz kargo — Türkiye geneli":"Free shipping over ₺1,500 — across Türkiye",
"B2B / Bayilik":"B2B / Dealership","Sipariş Takibi":"Order Tracking","Hakkımızda":"About Us","İletişim":"Contact",
"Tüm Kategoriler":"All Categories","Favoriler":"Favorites","Hesabım":"Account","Sepetim":"Cart","Fırsatlar":"Deals",
"Mobilya Kulpları":"Furniture Handles","Kapı Kolları":"Door Handles","Kilit & Güvenlik":"Locks & Security","Kilit ve Güvenlik":"Locks & Security",
"Menteşeler":"Hinges","Menteşeler ve Raylar":"Hinges & Slides","Askılıklar":"Hooks","Mobilya Hırdavatı":"Furniture Hardware",
"Vida & Dübel":"Screws & Plugs","Vida Çivi & Dübel":"Screws, Nails & Plugs","Yapıştırıcı & Bant":"Adhesives & Tape","Yapıştırıcı ve Bantlar":"Adhesives & Tape","Akıllı Kilit":"Smart Lock",
"Kategoriler":"Categories","Projene göre doğru donanımı seç":"Find the right hardware for your project","Tümünü Gör →":"View All →","Tümü →":"All →","Keşfet →":"Explore →",
"Kaplamaya Göre Alışveriş":"Shop by Finish","Aynı seride tüm ürünler, tek tonda":"A whole series in one tone",
"Mat Siyah Serisi":"Matte Black Series","Mat Altın Serisi":"Matte Gold Series","Antik & Altın":"Antique & Gold","Krom & İnox":"Chrome & Inox",
"Haftanın Seçimleri":"Weekly Picks","Editör önerisi premium parçalar":"Editor's premium picks",
"Fırsat Reyonu":"Deals Corner","Sınırlı süre indirimli donanım":"Limited-time discounted hardware","Tüm Fırsatlar →":"All Deals →",
"Yeni Gelenler":"New Arrivals","Depoya bu hafta giren ürünler":"Arrived in stock this week",
"İlham Veren Detaylar":"Inspiring Details","Doğru donanım, mekânın karakterini belirler":"The right hardware defines a space",
"Shop the Look":"Shop the Look","Rehber & Blog":"Guide & Blog","Doğru seçim için pratik, uzman rehberler":"Practical, expert guides",
"Markalar":"Brands","Çalıştığımız güvenilir markalar":"Trusted brands we work with",
"Detay değişir, evin hissi değişir.":"Change the detail, change how home feels.",
"Kategorileri Keşfet":"Explore Categories","Yaşam Alanı":"Living Space","Mutfak":"Kitchen","Gardırop":"Wardrobe","Kapılar":"Doors","Güvenlik":"Security",
"Hızlı Kargo":"Fast Shipping","Güvenli Ödeme":"Secure Payment","Orijinal & Faturalı":"Original & Invoiced","Kolay İade":"Easy Returns",
"Türkiye geneli, aynı gün sevkiyat":"Same-day dispatch across Türkiye","%100 orijinal ürün":"100% original product","14 gün içinde koşulsuz":"Unconditional within 14 days",
"Stokta":"In Stock","Tükendi":"Sold Out","Sepete Ekle":"Add to Cart","Sepete Git →":"Go to Cart →","Ödemeye Geç →":"Checkout →","Ödemeye Geç":"Checkout",
"Ürün Bilgileri":"Product Details","Açıklama":"Description","Ürün Açıklaması":"Product Description","Marka":"Brand","Kategori":"Category","Stok Kodu":"SKU","Durum":"Status",
"Sepetim":"My Cart","Sipariş Özeti":"Order Summary","Ara Toplam":"Subtotal","Toplam":"Total","Kargo":"Shipping","İndirim":"Discount","Ücretsiz":"Free","Ödemede hesaplanır":"Calculated at checkout","KDV dahildir":"VAT included",
"Kupon kodu":"Coupon code","Uygula":"Apply","Sipariş notu (opsiyonel)":"Order note (optional)","Sepetiniz henüz boş":"Your cart is empty","Alışverişe Başla":"Start Shopping","← Alışverişe devam et":"← Continue shopping","Kaldır":"Remove",
"Sepet":"Cart","Teslimat":"Delivery","Ödeme":"Payment",
"Giriş Yap":"Sign In","Üye Ol":"Sign Up","Şifremi unuttum":"Forgot password","E-posta":"Email","Şifre":"Password","Çıkış Yap":"Sign Out","Siparişlerim":"My Orders","Adreslerim":"My Addresses","Favorilerim":"My Favorites",
"Kurumsal":"Corporate","Müşteri Hizmetleri":"Customer Service","Bizi Takip Edin":"Follow Us","Kargo & Teslimat":"Shipping & Delivery","İade & Değişim":"Returns & Exchange","Sıkça Sorulanlar":"FAQ","Mağazalarımız":"Our Stores",
"Gizlilik & KVKK":"Privacy & GDPR","Mesafeli Satış Sözleşmesi":"Distance Sales Agreement","Teslimat & İade Koşulları":"Shipping & Return Terms","Çerez Politikası":"Cookie Policy","SSS":"FAQ",
"Güvenli alışveriş":"Secure shopping","© 2026 AKZERN YAPI · Tüm hakları saklıdır.":"© 2026 AKZERN YAPI · All rights reserved.",
"Çok Yakında Hizmetinizde":"Coming Soon","Haberdar Et":"Notify Me","Gönder":"Send","Bize Yazın":"Write to Us",
"Bu Salonu AKZERN Tamamlıyor":"AKZERN Completes This Room","Ürüne git →":"View product →",
"Detaylarda kalite":"Quality in the details"
};
function applyLang(){
  if(getLang()!=='en') return;
  try{document.documentElement.setAttribute('lang','en');}catch(e){}
  var root=document.body||document.documentElement;
  var w=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  var nodes=[],n; while(n=w.nextNode()){ nodes.push(n); }
  nodes.forEach(function(nd){ var raw=nd.nodeValue; if(!raw) return; var t=raw.trim(); if(t && I18N[t]){ nd.nodeValue=raw.replace(t,I18N[t]); } });
  document.querySelectorAll('[placeholder]').forEach(function(el){var t=(el.getAttribute('placeholder')||'').trim(); if(I18N[t]) el.setAttribute('placeholder',I18N[t]);});
}
function langInit(){
  var sw=document.getElementById('langSw');
  if(sw){ var cur=getLang();
    sw.querySelectorAll('.langsw__b').forEach(function(b){
      b.classList.toggle('on', b.getAttribute('data-lang')===cur);
      b.addEventListener('click',function(e){e.preventDefault(); var L=b.getAttribute('data-lang');
        try{localStorage.setItem('ak_lang',L);}catch(e2){}
        if(window.SHOPIFY){ location.href=(L==='en'?'/en':'/'); }
        else { location.reload(); }
      });
    });
  }
  applyLang();
}

const NAV = [
  ["Mobilya Kulpları","mobilya-kulplari"],["Kapı Kolları","kapi-kollari"],
  ["Kilit & Güvenlik","kilit-ve-guvenlik-urunleri"],["Menteşeler","menteseler"],
  ["Askılıklar","askiliklar"],["Mobilya Hırdavatı","mobilya-hirdavati"],
  ["Vida & Dübel","vida-civi-dubel"],["Yapıştırıcı & Bant","yapistirici-ve-bantlar"]
];

/* mega dropdown categories (thumb + count) + hover lifestyle (Nano Banana Pro) */
const MEGA = [
  ["Mobilya Kulpları","273","cat-kulp.jpg","cat-kulp.jpg","mobilya-kulplari"],
  ["Kapı Kolları","180","cat-kapikol.jpg","cat-kapikol.jpg","kapi-kollari"],
  ["Kilit ve Güvenlik","156","cat-kilitg.jpg","cat-kilitg.jpg","kilit-ve-guvenlik-urunleri"],
  ["Menteşeler","34","cat-mentese.jpg","cat-mentese.jpg","menteseler"],
  ["Askılıklar","86","cat-aski.jpg","cat-aski.jpg","askiliklar"],
  ["Mobilya Hırdavatı","106","cat-hirdavat.jpg","cat-hirdavat.jpg","mobilya-hirdavati"],
  ["Vida Çivi & Dübel","117","cat-vida.jpg","cat-vida.jpg","vida-civi-dubel"],
  ["Yapıştırıcı ve Bantlar","12","cat-bant.jpg","cat-bant.jpg","yapistirici-ve-bantlar"],
];

function topHTML(){
  return `
  <div class="announce"><div class="announce__track" id="annTrack"></div></div>
  <div class="topbar"><div class="wrap">
    <div class="topbar__left"><span class="hot">🚚 <b>1.500 ₺</b> üzeri ücretsiz kargo — Türkiye geneli</span></div>
    <div class="topbar__right">
      <a href="${window.SHOPIFY?'/pages/bayilik':'bayilik.html'}">B2B / Bayilik</a><span class="sep">|</span>
      <a href="${P('siparis-takibi')}">Sipariş Takibi</a><span class="sep">|</span>
      <a href="tel:${INFO.telRaw}">${INFO.tel}</a><span class="sep">|</span>
      <a href="${P('hakkimizda')}">Hakkımızda</a>
      <span class="langsw" id="langSw">
        <a class="langsw__b" data-lang="tr" href="#" aria-label="Türkçe"><img src="https://flagcdn.com/w40/tr.png" alt="TR"></a>
        <a class="langsw__b" data-lang="en" href="#" aria-label="English"><img src="https://flagcdn.com/w40/gb.png" alt="EN"></a>
      </span>
    </div>
  </div></div>

  <header class="header" id="siteHeader"><div class="wrap">
    <a class="brand" href="${window.SHOPIFY?'/':'index.html'}" aria-label="AKZERN YAPI ana sayfa">
      <img class="brand__logo" src="https://akzern.com/cdn/shop/files/akzern_yapi_logo.png" alt="AKZERN YAPI"
           onerror="this.style.display='none';this.nextElementSibling.style.display='inline-flex'">
      <span class="logo__fallback" style="display:none;font-family:var(--font-display);font-weight:800;font-size:26px;color:var(--brand-ink)">AKZERN<span style="color:var(--brand-accent)">YAPI</span></span>
      <span class="brand__hover" aria-hidden="true">
        <img class="brand__amark" src="${(window.ASSET_BASE||'assets/')}brand-a.png" alt="">
        <span class="brand__slogan" id="brandSlogan"></span>
        <span class="brand__uline"></span>
      </span>
    </a>

    <form class="search" onsubmit="return akSearch(event)">
      <div class="search__cat">Tüm Kategoriler <svg viewBox="0 0 24 24" width="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></div>
      <input placeholder="Kulp, kilit, menteşe, vida veya marka ara…" aria-label="Ara">
      <button class="search__btn" aria-label="Ara"><svg viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg></button>
    </form>

    <nav class="header__actions">
      <a class="act" href="${window.SHOPIFY?'/pages/favoriler':'favoriler.html'}"><span class="badge" id="favBadge" style="display:none">0</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21c-4-3-8-6.3-8-11a4 4 0 018-1 4 4 0 018 1c0 4.7-4 8-8 11z"/></svg><span>Favoriler</span></a>
      <a class="act" href="${window.SHOPIFY?'/account':'#'}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0116 0"/></svg><span>Hesabım</span></a>
      <a class="act" href="${cartURL()}"><span class="badge" id="cartBadge">0</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M6 6L5 3H2"/></svg><span>Sepetim</span></a>
    </nav>
  </div></header>

  <nav class="mega-bar" id="megaBar"><div class="wrap">
    <button class="mega-all" id="megaAll" type="button"><svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 6h16M4 12h16M4 18h16"/></svg>Tüm Kategoriler <svg class="chev" viewBox="0 0 24 24" width="14" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 9l6 6 6-6"/></svg></button>
    ${NAV.map(n=>`<a class="mega-link" href="${colURL(n[1])}">${n[0]}</a>`).join('')}
    <a class="mega-link is-deal" href="${allColURL()}">Fırsatlar</a>

    <div class="mega-panel" id="megaPanel">
      <div class="mega-panel__in">
        <div class="mega-cats" id="megaCats"></div>
        <div class="mega-preview">
          <div class="mega-life" id="megaLife">
            <img src="${LIFE}cat-kulp.jpg" alt="" id="megaLifeImg">
            <div class="mega-life__cap"><h4 id="megaLifeT">Mobilya Kulpları</h4><span id="megaLifeC">273 ürün →</span></div>
          </div>
          <a class="mega-promo" href="${window.SHOPIFY?'/pages/bayilik':'bayilik.html'}">
            <img src="${LIFE}nb-collage.jpg" alt="">
            <div class="mega-promo__cap"><h4>Toptan Alım</h4><span>Bayilere özel fiyat →</span></div>
          </a>
        </div>
      </div>
    </div>
  </div></nav>`;
}

function footHTML(){
  return `
  <footer class="footer"><div class="wrap">
    <div class="footer__top">
      <div class="footer__brand">
        <a href="${window.SHOPIFY?'/':'index.html'}" style="display:inline-flex;background:#fff;padding:11px 15px;border-radius:12px" aria-label="AKZERN YAPI"><img src="https://akzern.com/cdn/shop/files/akzern_yapi_logo.png" alt="AKZERN YAPI" style="height:40px;width:auto;display:block" onerror="this.parentNode.innerHTML='<span style=&quot;font-family:var(--font-display);font-weight:800;font-size:24px;color:#211E1B&quot;>AKZERN<span style=&quot;color:#E5661C&quot;>YAPI</span></span>'"></a>
        <p style="margin-top:16px">Mobilya hırdavatı, kulp, kilit ve yapı malzemelerinde güvenilir tedarik noktanız. Perakende hız, toptan fiyat.</p>
        <ul class="footer__contact">
          <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 21s-7-5.5-7-11a7 7 0 0114 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg> ${INFO.adres}</li>
          <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M4 5h4l2 5-2 1a12 12 0 005 5l1-2 5 2v4a2 2 0 01-2 2A16 16 0 013 7a2 2 0 011-2z"/></svg> ${INFO.tel}</li>
          <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg> ${INFO.mail}</li>
        </ul>
      </div>
      <div class="footer__col"><h4>Kategoriler</h4>
        <a href="${colURL('mobilya-kulplari')}">Mobilya Kulpları</a><a href="${colURL('kapi-kollari')}">Kapı Kolları</a>
        <a href="${colURL('kilit-ve-guvenlik-urunleri')}">Kilit & Güvenlik</a><a href="${colURL('menteseler')}">Menteşeler</a><a href="${colURL('vida-civi-dubel')}">Vida & Dübel</a>
      </div>
      <div class="footer__col"><h4>Kurumsal</h4>
        <a href="${window.SHOPIFY?'/pages/hakkimizda':'hakkimizda.html'}">Hakkımızda</a><a href="${window.SHOPIFY?'/pages/bayilik':'bayilik.html'}">B2B / Bayilik</a><a href="${window.SHOPIFY?'/pages/iletisim':'iletisim.html'}">İletişim</a><a href="${P('iletisim')}">Mağazalarımız</a>
      </div>
      <div class="footer__col"><h4>Müşteri Hizmetleri</h4>
        <a href="${window.SHOPIFY?'/account':'#'}">Siparişlerim</a><a href="${P('teslimat-iade')}">Kargo & Teslimat</a><a href="${P('teslimat-iade')}">İade & Değişim</a><a href="${P('sss')}">Sıkça Sorulanlar</a>
      </div>
      <div class="footer__col"><h4>Bizi Takip Edin</h4>
        <div class="socials">
          <a href="https://instagram.com/akzernyapi" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" width="17" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1"/></svg></a>
          <a href="https://www.facebook.com/profile.php?id=61581781594899" target="_blank" rel="noopener" aria-label="Facebook"><svg viewBox="0 0 24 24" width="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 3h-3a4 4 0 00-4 4v3H5v4h3v7h4v-7h3l1-4h-4V7a1 1 0 011-1h3z"/></svg></a>
          <a href="https://wa.me/908502417748" target="_blank" rel="noopener" aria-label="WhatsApp"><svg viewBox="0 0 24 24" width="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3a9 9 0 00-7.7 13.6L3 21l4.5-1.2A9 9 0 1012 3z"/><path d="M8.5 9c0 4 3 6.5 6.5 6.5"/></svg></a>
        </div>
        <div style="margin-top:18px;font-size:12.5px">Güvenli alışveriş<br><b style="color:#fff">256-bit SSL · 3D Secure</b></div>
      </div>
    </div>
    <div class="footer__policies">
      <a href="${P('gizlilik-politikasi')}">Gizlilik & KVKK</a>
      <a href="${P('satis-sozlesmesi')}">Mesafeli Satış Sözleşmesi</a>
      <a href="${P('teslimat-iade')}">Teslimat & İade Koşulları</a>
      <a href="${P('cerez-politikasi')}">Çerez Politikası</a>
      <a href="${P('sss')}">SSS</a>
    </div>
    <div class="footer__bottom">
      <span class="copy">© 2026 AKZERN YAPI · Tüm hakları saklıdır.</span>
      <div class="pay"><span>VISA</span><span>MASTERCARD</span><span>TROY</span><span>HAVALE</span></div>
    </div>
  </div></footer>

  <div class="toast-wrap" id="toastWrap"></div>

  <button class="tweak__toggle" id="tkToggle" aria-label="Tema rengi">
    <svg viewBox="0 0 24 24" width="22" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 000 18 3 3 0 000-6 2 2 0 010-4 3 3 0 000-8z"/></svg>
  </button>
  <div class="tweak" id="tkPanel" style="display:none">
    <h5>Tema Rengi (deneme)</h5>
    <div class="tweak__row">
      <button data-set="charcoal" class="is-active"><span class="tweak__sw" style="background:#E5661C;border:2px solid #211E1B"></span>Charcoal+Turuncu</button>
      <button data-set="teal"><span class="tweak__sw" style="background:#00A6A0"></span>Teal</button>
      <button data-set="red"><span class="tweak__sw" style="background:#E2231A"></span>Kırmızı</button>
    </div>
    <div class="n">Beğendiğin yönü seç; canlı temayı ona göre kuralım.</div>
  </div>`;
}

/* ---- product card helper ---- */
function stars(r){const f=Math.round(parseFloat(r));return "★★★★★".slice(0,f)+"☆☆☆☆☆".slice(0,5-f);}
function card(p){
  return `<article class="card reveal" data-brand="${p.b}" data-name="${p.t}" data-price="${p.p}">
    ${p.badge?`<span class="card__badge" ${p.badge==='YENİ'?'style="background:var(--success)"':''}>${p.badge}</span>`:''}
    <button class="card__fav" aria-label="Favori"><svg viewBox="0 0 24 24" width="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21c-4-3-8-6.3-8-11a4 4 0 018-1 4 4 0 018 1c0 4.7-4 8-8 11z"/></svg></button>
    <a class="card__media" href="urun.html"><img src="${IMG}${p.img}" alt="${p.t}" loading="lazy"></a>
    <div class="card__body">
      <span class="card__brand">${p.b}</span>
      <a class="card__title" href="urun.html">${p.t}</a>
      <div class="card__rating"><span class="stars">${stars(p.r)}</span> ${p.r} <span style="color:var(--text-3)">(${p.n})</span></div>
      ${(p.dots&&p.dots.length)?`<div class="card__variants">${p.dots.map(d=>`<span class="dot dot--${d}" title="${d}"></span>`).join('')}</div>`:'<div style="height:15px"></div>'}
      <div class="card__stock">Stokta</div>
      <div class="card__foot">
        <div class="price">${p.o?`<span class="price__old">${p.o} ₺</span>`:''}<span class="price__now">${p.p} <small>₺</small></span></div>
        <button class="card__add" aria-label="Sepete ekle"><svg viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12h14"/></svg></button>
      </div>
    </div>
  </article>`;
}

/* ---- CART (localStorage) ---- */
function akCartGet(){if(window.SHOPIFY&&typeof window.CART_COUNT==='number')return window.CART_COUNT;return parseInt(localStorage.getItem('ak_cart')||'0',10);}
function akCartSet(n){localStorage.setItem('ak_cart',n);document.querySelectorAll('#cartBadge,.badge').forEach(b=>b.textContent=n);}
function akAddToCart(name,qty){qty=qty||1;akCartSet(akCartGet()+qty);akToast(`<b>Sepete eklendi</b> · ${name}`);}

/* ---- TOAST ---- */
function akToast(html){
  const w=document.getElementById('toastWrap'); if(!w)return;
  const t=document.createElement('div'); t.className='toast';
  t.innerHTML=`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg><span>${html}</span>`;
  w.appendChild(t); requestAnimationFrame(()=>t.classList.add('in'));
  setTimeout(()=>{t.classList.remove('in');setTimeout(()=>t.remove(),400);},2600);
}
function akSearch(e){e.preventDefault();const q=e.target.querySelector('input').value.trim();if(q)location.href=window.SHOPIFY?('/search?q='+encodeURIComponent(q)):'koleksiyon.html';return false;}

/* ---- mount + interactions ---- */
function mountSite(){
  const top=document.getElementById('site-top'); if(top) top.innerHTML=topHTML();
  const foot=document.getElementById('site-foot'); if(foot) foot.innerHTML=footHTML();

  akCartSet(akCartGet()); /* sync badge */

  /* announcement */
  const ann=document.getElementById('annTrack');
  if(ann){
    const items=[
      ['🚚','<b>1.500 ₺</b> üzeri ücretsiz kargo'],
      ['🛡️','<b>%100 Orijinal & Faturalı</b> ürün'],
      ['🏷️','Toptan alımda <b>bayilere özel fiyat</b>'],
      ['🧰','<b>15.000+ ürün</b>, tek adres: AKZERN YAPI'],
    ];
    const row=items.map(i=>`<span>${i[0]} ${i[1]}</span>`).join('');
    ann.innerHTML=row+row;
  }

  /* mega dropdown */
  const megaCats=document.getElementById('megaCats');
  if(megaCats){
    megaCats.innerHTML=MEGA.map((c,i)=>`<a class="mega-cat${i===0?' hot':''}" href="${colURL(c[4])}" data-life="${c[3]}" data-t="${c[0]}" data-c="${c[1]}">
      <img src="${LIFE}${c[2]}" alt="" loading="lazy"><div><div class="mega-cat__t">${c[0]}</div><div class="mega-cat__c">${c[1]} ürün</div></div></a>`).join('');
    const bar=document.getElementById('megaBar'),all=document.getElementById('megaAll');
    const open=v=>bar.classList.toggle('open',v);
    all.addEventListener('click',e=>{e.stopPropagation();open(!bar.classList.contains('open'));});
    all.addEventListener('mouseenter',()=>open(true));
    bar.addEventListener('mouseleave',()=>open(false));
    document.addEventListener('click',()=>open(false));
    document.getElementById('megaPanel').addEventListener('click',e=>e.stopPropagation());
    const li=document.getElementById('megaLifeImg'),lt=document.getElementById('megaLifeT'),lc=document.getElementById('megaLifeC');
    megaCats.querySelectorAll('.mega-cat').forEach(el=>el.addEventListener('mouseenter',()=>{
      megaCats.querySelectorAll('.mega-cat').forEach(x=>x.classList.remove('hot'));el.classList.add('hot');
      li.src=LIFE+el.dataset.life; lt.textContent=el.dataset.t; lc.textContent=el.dataset.c+' ürün →';
    }));
  }

  /* header shrink */
  const h=document.getElementById('siteHeader');
  if(h){const onScroll=()=>h.classList.toggle('is-shrink',window.scrollY>60);window.addEventListener('scroll',onScroll,{passive:true});onScroll();}

  /* theme accent toggle */
  const panel=document.getElementById('tkPanel'),tog=document.getElementById('tkToggle');
  if(tog){tog.onclick=()=>{panel.style.display=panel.style.display==='none'?'block':'none';};
    panel.querySelectorAll('[data-set]').forEach(b=>b.onclick=()=>{
      document.documentElement.setAttribute('data-accent',b.dataset.set);
      panel.querySelectorAll('[data-set]').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');});}

  /* global delegation: add-to-cart + favorite on product cards */
  document.addEventListener('click',e=>{
    const add=e.target.closest('.card__add');
    if(add){e.preventDefault();const c=add.closest('.card');const vid=c&&c.dataset.vid;
      if(window.SHOPIFY&&vid){
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
          .then(r=>r.json()).then(()=>fetch('/cart.js')).then(r=>r.json()).then(d=>{window.CART_COUNT=d.item_count;akCartSet(d.item_count);akToast(`<b>Sepete eklendi</b> · ${c.dataset.name||'Ürün'}`);})
          .catch(()=>akToast('Sepete eklenemedi'));
      } else { akAddToCart(c?.dataset.name||'Ürün'); }
      return;}
    const fav=e.target.closest('.card__fav');
    if(fav){e.preventDefault();const c=fav.closest('.card');
      const item={url:(c&&c.dataset.url)||'',name:(c&&c.dataset.name)||'Ürün',img:(c&&c.dataset.img)||'',price:(c&&c.dataset.price)||''};
      const on=akFavToggle(item); fav.classList.toggle('is-active',on);
      akToast(on?'<b>Favorilere eklendi</b>':'Favorilerden çıkarıldı');}
  });

  akFavSyncUI();
  /* logo hover sloganı: harf harf soldan sağa (el yazısı) */
  var sl=document.getElementById('brandSlogan');
  if(sl){var s='detaylarda kalite...'; sl.innerHTML=s.split('').map(function(ch,i){return '<span style="transition-delay:'+(i*0.032).toFixed(3)+'s">'+(ch===' '?'&nbsp;':ch)+'</span>';}).join('');}
  langInit();
  initReveal(); initCountUp();
}

/* ---- FAVORİLER (localStorage wishlist) ---- */
function akFavGet(){try{return JSON.parse(localStorage.getItem('ak_fav')||'[]');}catch(e){return [];}}
function akFavSet(a){localStorage.setItem('ak_fav',JSON.stringify(a));akFavBadge();}
function akFavKey(i){return i.url||i.name;}
function akFavToggle(item){var a=akFavGet();var k=akFavKey(item);var i=a.findIndex(function(x){return akFavKey(x)===k;});
  if(i>=0){a.splice(i,1);akFavSet(a);return false;} a.unshift(item);akFavSet(a);return true;}
function akFavBadge(){var n=akFavGet().length;var b=document.getElementById('favBadge');if(b){b.textContent=n;b.style.display=n?'grid':'none';}}
function akFavSyncUI(){akFavBadge();var keys={};akFavGet().forEach(function(x){keys[akFavKey(x)]=1;});
  document.querySelectorAll('.card').forEach(function(c){var k=c.dataset.url||c.dataset.name;var f=c.querySelector('.card__fav');if(f&&keys[k])f.classList.add('is-active');});}

/* scroll reveal */
function initReveal(){
  const els=document.querySelectorAll('.reveal:not(.in)');
  if(!('IntersectionObserver' in window)){els.forEach(e=>e.classList.add('in'));return;}
  const io=new IntersectionObserver((ents)=>{ents.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
  els.forEach(e=>io.observe(e));
  /* güvence: viewport'a giren/yakın olanı hemen aç */
  setTimeout(()=>document.querySelectorAll('.reveal:not(.in)').forEach(e=>{
    if(e.getBoundingClientRect().top < innerHeight*1.15) e.classList.add('in');
  }),300);
}
function initCountUp(){
  const els=document.querySelectorAll('[data-count]');
  if(!els.length)return;
  const io=new IntersectionObserver((ents)=>{ents.forEach(e=>{
    if(!e.isIntersecting)return; io.unobserve(e.target);
    const el=e.target, end=parseFloat(el.dataset.count), suf=el.dataset.suffix||'', dur=1200; let s=null;
    const step=(t)=>{if(!s)s=t;const p=Math.min((t-s)/dur,1);const v=Math.floor(p*end);
      el.textContent=v.toLocaleString('tr-TR')+suf; if(p<1)requestAnimationFrame(step); else el.textContent=end.toLocaleString('tr-TR')+suf;};
    requestAnimationFrame(step);
  });},{threshold:.5});
  els.forEach(e=>io.observe(e));
}
function refreshReveal(){initReveal();}

/* ---- scroll-driven cinematic hero (image-sequence crossfade) ---- */
function initCine(){
  const cine=document.getElementById('cine'); if(!cine)return;
  const f1=document.getElementById('cf1'),f2=document.getElementById('cf2'),f3=document.getElementById('cf3');
  const cap1=document.getElementById('cap1'),cap3=document.getElementById('cap3'),hint=document.getElementById('cineHint');
  const seg=(p,a,b)=>Math.max(0,Math.min(1,(p-a)/(b-a)));
  function frame(){
    const total=cine.offsetHeight-window.innerHeight;
    const p=Math.max(0,Math.min(1,(-cine.getBoundingClientRect().top)/total)); /* 0..1 */
    const o1=1-seg(p,.26,.44);
    const o2=seg(p,.28,.44)*(1-seg(p,.58,.72));
    const o3=seg(p,.6,.74);
    if(f1)f1.style.opacity=o1.toFixed(3);
    if(f2)f2.style.opacity=o2.toFixed(3);
    if(f3)f3.style.opacity=o3.toFixed(3);
    const sc=(1.05+p*0.08).toFixed(3);
    [f1,f2,f3].forEach(f=>{if(f)f.style.transform=`scale(${sc})`;});
    if(cap1){cap1.style.opacity=(1-seg(p,.08,.24)).toFixed(3);cap1.style.transform=`translateY(${-seg(p,.08,.24)*20}px)`;}
    if(cap3){const v=seg(p,.64,.82);cap3.style.opacity=v.toFixed(3);cap3.style.transform=`translateY(${(1-v)*26}px)`;}
    if(hint)hint.style.opacity=(1-seg(p,.02,.12)).toFixed(3);
  }
  window.addEventListener('scroll',frame,{passive:true});
  window.addEventListener('resize',frame); frame();
}
/* simple parallax for [data-parallax] backgrounds */
function initParallax(){
  const els=document.querySelectorAll('[data-parallax]');
  if(!els.length)return;
  const f=()=>els.forEach(el=>{const r=el.getBoundingClientRect();const off=(r.top+r.height/2-window.innerHeight/2)*-0.06;el.style.transform=`translateY(${off}px) scale(1.12)`;});
  window.addEventListener('scroll',f,{passive:true});window.addEventListener('resize',f);f();
}

/* ====== KESİN GARANTİ: yükleme sonrası TÜM bölümler görünür olsun (JS ne olursa olsun) ====== */
(function(){
  function revealAll(){ document.querySelectorAll('.reveal:not(.in)').forEach(function(e){ e.classList.add('in'); }); }
  if(document.readyState==='complete') setTimeout(revealAll, 800);
  else window.addEventListener('load', function(){ setTimeout(revealAll, 800); });
})();
